var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        key: _vm.resetTab,
        attrs: {
          list: _vm.statusTab,
          filter: _vm.filter,
          status: _vm.basicStatusTab,
          title: "Documentos emitidos",
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        on: {
          "update:filter": function ($event) {
            _vm.filter = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm.$helpers.hasSomePermission(["view_document"])
              ? {
                  key: "main",
                  fn: function () {
                    return [
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              disabled: !Object.keys(_vm.$route.query)?.length,
                              outlined: "",
                            },
                            on: { click: _vm.getList },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                contain: "",
                                src: require(`@/assets/icon-update${
                                  _vm.$vuetify.theme.dark ? "-dark" : ""
                                }.svg`),
                              },
                            }),
                          ],
                          1
                        ),
                        _c("VMainColumnRecordVisualization", {
                          attrs: {
                            headers: _vm.headersAux,
                            pageSize: _vm.pageSize,
                            object: "documents",
                          },
                          on: {
                            "update:headers": function ($event) {
                              _vm.headersAux = $event
                            },
                            "update:pageSize": function ($event) {
                              _vm.pageSize = $event
                            },
                            "update:page-size": function ($event) {
                              _vm.pageSize = $event
                            },
                          },
                        }),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "close-on-click": "",
                              "close-on-content-click": "",
                              "offset-y": "",
                              left: "",
                              "nudge-bottom": 10,
                              transition: "slide-y-transition",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "ml-2",
                                              attrs: { outlined: "" },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-plus-box ")]
                                          ),
                                          _vm._v("Opciones"),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { size: "18", right: "" },
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3671956459
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              { staticClass: "pa-0" },
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "px-3",
                                    attrs: {
                                      disabled: !_vm.selectedDocuments?.length,
                                      ripple: false,
                                    },
                                    on: { click: _vm.createExport },
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-1 grey-500--text" },
                                      [_vm._v("Descargar documentos")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "px-3",
                                    attrs: {
                                      disabled: !_vm.selectedDocuments?.length,
                                      ripple: false,
                                    },
                                    on: { click: _vm.createExportPdf },
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-1 grey-500--text" },
                                      [_vm._v("Descargar PDF")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "px-3",
                                    attrs: {
                                      disabled: !_vm.count,
                                      ripple: false,
                                    },
                                    on: { click: _vm.createDownloadList },
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-1 grey-500--text" },
                                      [_vm._v("Descargar listado")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      color: "grey-background",
                                      right: "",
                                      "max-width": "185px",
                                      transition: "scale-transition",
                                      "open-delay": "1000",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "grey-500--text body-1",
                                                  },
                                                  !_vm.selectedDocuments?.length
                                                    ? on
                                                    : false
                                                ),
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-3",
                                                      attrs: {
                                                        ripple: false,
                                                        disabled:
                                                          !_vm.selectedDocuments
                                                            ?.length,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.sendEmailDialog = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "body-1 grey-500--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Enviar documentos por mail"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1721645685
                                    ),
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "d-block px-3 py-2" },
                                      [
                                        _vm._v(
                                          "Debe seleccionar documentos antes de seleccionar una opción"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-query-builder", {
                          staticClass: "mx-2",
                          attrs: {
                            "query-map": _vm.filters,
                            model: "documents",
                            active: _vm.activeFilter,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.activeFilter = $event
                            },
                          },
                        }),
                        _vm.$helpers.hasSomePermission(["add_document"]) &&
                        _vm.$store.state.auth.account.country !== "PE"
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "grey-900",
                                  to: {
                                    name: "DocumentsCreate",
                                    params: _vm.$route.params,
                                  },
                                  ripple: false,
                                },
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-file-plus"),
                                ]),
                                _vm._v("Crear documento"),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.$helpers.hasSomePermission(["view_document"])
              ? {
                  key: "custom-tab",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        {
                          staticClass: "mt-14 ml-n6 mr-5",
                          style: `min-width: 100%; border-bottom: 1px solid var(--${
                            _vm.$vuetify.theme.dark ? "dark" : "light"
                          }-grey-50)`,
                          attrs: { "no-gutters": "", align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 background",
                              attrs: { cols: "7" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "subtitle-2 grey-700--text font-weight-medium",
                                },
                                [
                                  _vm._v(
                                    "Estado " + _vm._s(_vm.$t("generals.SII"))
                                  ),
                                ]
                              ),
                              _c(
                                "v-tabs",
                                {
                                  key: _vm.resetTab,
                                  ref: "siiTabs",
                                  staticClass: "background pa-0 tab-rec",
                                  attrs: { height: 35 },
                                  model: {
                                    value: _vm.filter,
                                    callback: function ($$v) {
                                      _vm.filter = $$v
                                    },
                                    expression: "filter",
                                  },
                                },
                                [
                                  _c(
                                    "v-tab",
                                    { attrs: { ripple: false } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-ballot")]
                                      ),
                                      _vm._v("Todos "),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.basicStatusTab,
                                    function (status, i) {
                                      return _c(
                                        "v-tab",
                                        { key: i, attrs: { ripple: false } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v(_vm._s(status.icon))]
                                          ),
                                          _vm._v(_vm._s(status.title) + " "),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 text-right",
                              attrs: { cols: "3" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "subtitle-2 ml-n2 grey-700--text font-weight-medium",
                                },
                                [_vm._v("Estado comercial")]
                              ),
                              _c(
                                "v-tabs",
                                {
                                  key: _vm.$store.state.base
                                    .isExpandNavigationDrawer,
                                  ref: "recStatusTabs",
                                  staticClass: "background mr-0 tab-rec",
                                  attrs: { height: 35, right: true },
                                  model: {
                                    value: _vm.recStatusFilter,
                                    callback: function ($$v) {
                                      _vm.recStatusFilter = $$v
                                    },
                                    expression: "recStatusFilter",
                                  },
                                },
                                _vm._l(_vm.recStatusTabs, function (status, i) {
                                  return _c(
                                    "v-tab",
                                    { key: i, attrs: { ripple: false } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-" + _vm._s(status.icon))]
                                      ),
                                      _vm._v(_vm._s(status.title) + " "),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-25 pb-10", attrs: { cols: "12" } },
        [
          _c("documents-list", {
            key: _vm.reset,
            attrs: {
              "show-create": true,
              hasPermission: _vm.$helpers.hasSomePermission(["view_document"]),
              selectedDocuments: _vm.selectedDocuments,
              toggleDropdown: _vm.toggleDropdown,
              headerList: _vm.headerList,
              pageSize: _vm.pageSize,
            },
            on: {
              activeBtnFilter: function ($event) {
                _vm.activeFilter = true
              },
              "update:selectedDocuments": function ($event) {
                _vm.selectedDocuments = $event
              },
              "update:selected-documents": function ($event) {
                _vm.selectedDocuments = $event
              },
              "update:toggleDropdown": function ($event) {
                _vm.toggleDropdown = $event
              },
              "update:toggle-dropdown": function ($event) {
                _vm.toggleDropdown = $event
              },
              getList: _vm.getList,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Descarga de documentos emitidos")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogExport = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text body-1 font-weight-semibold",
                                },
                                [
                                  _vm._v(
                                    "Selecciona el formato de los archivos:"
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ml-n1",
                                      attrs: { "no-gutters": "" },
                                    },
                                    _vm._l(_vm.fileFormat, function (file) {
                                      return _c(
                                        "v-col",
                                        {
                                          key: file,
                                          staticClass: "pa-0",
                                          attrs: { cols: "6" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 vcheckbox",
                                            attrs: {
                                              "input-value":
                                                _vm.types.includes(file) ||
                                                false,
                                              column: "",
                                              label: file,
                                              disabled:
                                                ["XLSX", "CSV", "XML"].includes(
                                                  file
                                                ) && _vm.count >= 1000000,
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getFileFormat(file)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass:
                        "inf-alert-blue green-500--text rounded-md mt-2",
                      attrs: { height: 58, dense: "", text: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 my-1" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-900", size: "22" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "body-2",
                                staticStyle: { "line-height": "14px" },
                              },
                              [
                                _vm._v("Esta acción "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("podría tardar varios minutos")]
                                ),
                                _vm._v(" en completarse. Recibirás un "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      " correo electrónico con el enlace de descarga."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogExport = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        ripple: false,
                        disabled: !_vm.types?.length,
                      },
                      on: { click: _vm.createExport },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.sendEmailDialog,
            callback: function ($$v) {
              _vm.sendEmailDialog = $$v
            },
            expression: "sendEmailDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Envío de documentos por mail")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.sendEmailDialog = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c("v-list", { staticClass: "v-list-form pa-0 transparent" }),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "grey-500--text body-1",
                          staticStyle: { "min-width": "60px" },
                        },
                        [_vm._v("Para")]
                      ),
                      _c("v-combobox", {
                        key: _vm.key,
                        ref: "email",
                        staticClass: "a-combobox",
                        attrs: {
                          "hide-details": "",
                          items: _vm.emailsList,
                          outlined: "",
                          required: "",
                          "hide-selected": "",
                          placeholder: !_vm.messages?.recipient?.length
                            ? "Escribe el email del destinatario"
                            : "",
                          multiple: "",
                          "deletable-chips": "",
                          "small-chips": "",
                          dense: "",
                          "single-line": "",
                          autocomplete: "off",
                        },
                        on: { "update:search-input": _vm.setEmail },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function (data) {
                              return [
                                _c(
                                  "v-chip",
                                  _vm._b(
                                    {
                                      staticClass: "pr-2 ma-1 close-chip",
                                      attrs: {
                                        color: "green-100",
                                        "input-value": data.selected,
                                        close: "",
                                        small: "",
                                      },
                                      on: {
                                        click: data.select,
                                        "click:close": function ($event) {
                                          return _vm.remove(data.item)
                                        },
                                      },
                                    },
                                    "v-chip",
                                    data.attrs,
                                    false
                                  ),
                                  [_vm._v(_vm._s(data.item))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item",
                            fn: function (data) {
                              return [
                                _c(
                                  "v-list-item-avatar",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "grey-700" } },
                                      [_vm._v("mdi-account-circle")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", {
                                  staticClass: "ml-n2 font-weight-medium",
                                  domProps: { innerHTML: _vm._s(data.item) },
                                }),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.messages.recipient,
                          callback: function ($$v) {
                            _vm.$set(_vm.messages, "recipient", $$v)
                          },
                          expression: "messages.recipient",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.sendEmailDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.messages.createLoader,
                        color: "grey-900",
                      },
                      on: { click: _vm.createMail },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }